import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonService } from '../../service/common.service';
import { HorizontalBarService } from './horizontal-bar.service';
import { ChartResizeService } from '../../service/chart-resize.service';
import { ChartDarkModeService } from '../../service/chart-dark-mode.service'
import { horizontalBarData, axisLabelRotate } from './horizontal-bar-interface';
import { ChangeFilter } from '../../change-filter'
import { ECharts } from 'echarts'
import { initOpts } from '../../config/initOpts'
import { legendPosition } from './horizontal-bar-interface';
import * as backgroundColor from '../../config/backgroundColor';
import * as color from '../../config/colors';
import * as _ from 'lodash';


@Component({
  selector: 'bcac-horizontal-bar',
  templateUrl: './horizontal-bar.component.html',
  styleUrls: ['./horizontal-bar.component.scss']
})
export class HorizontalBarComponent implements OnInit {

  constructor(
    private horizontalBarService: HorizontalBarService,
    private chartResizeService: ChartResizeService,
    private chartDarkModeService: ChartDarkModeService,
    private commonService: CommonService
  ) { }

  options: any = this.horizontalBarService.getHorizontalBarDefaultOption();

  public _bcacChartTitle: { show: boolean, label: string } = {
    show: true,
    label: "图表标题"
  };
  // 是否显示标题
  @Input()
  set bcacChartShowTitle(show: boolean) {
    this._bcacChartTitle.show = show;
  }
  // 标题文字
  @Input()
  set bcacChartTitleText(text: string) {
    this._bcacChartTitle.label = text;
    this._bcacChartFileName = text;
  }
  // 图文件名
  public _bcacChartFileName: string = "图表";
  @Input()
  set bcacChartFileName(fileName: string) {
    this._bcacChartFileName = fileName;
  }

  // 是否显示toolbox
  /**
   * @deprecated
   */
  @Input()
  set bcacChartShowToolbox(show: boolean) {
    // this.horizontalBarService.changeToolboxShow(this.options, show)
  }

  // 输入是否显示图例
  @Input()
  set bcacChartShowLegend(bcacLegendShow: boolean) {

    this.horizontalBarService.changeLegendShow(this.options, bcacLegendShow);

    this.updateOptions()
  }
  // 输入tooltip的单位
  _bcacTooltipUnit: string = "";
  @Input()
  set bcacTooltipUnit(tooltipUnit: string) {
    this._bcacTooltipUnit = tooltipUnit;
    this.horizontalBarService.changeTooltip(this.options, tooltipUnit)
    this.updateOptions();
  }
  // x轴Name
  @Input()
  set bcacXAxisName(xAxisName: string) {
    this.horizontalBarService.changeXAxisName(this.options, xAxisName)
    this.updateOptions();
  }
  // 输入y轴名
  @Input()
  set bcacYAxisName(yAxisName: string) {
    this.horizontalBarService.changeYAxisName(this.options, yAxisName)
    this.updateOptions();
  }
  // 输入y轴名距离
  @Input()
  set bcacYAxisNameGap(yAxisNameGap: number) {
    this.horizontalBarService.changeYAxisNameGap(this.options, yAxisNameGap);
    this.updateOptions();
  }
  // x轴label的旋转 
  @Input()
  set bcacXAxisLabelRotate(xAxisLabelRotate: axisLabelRotate) {
    this.horizontalBarService.changeXAxisLabelRotate(this.options, xAxisLabelRotate);
    this.updateOptions();
  }
  // y轴label的旋转
  @Input()
  set bcacYAxisLabelRotate(yAxisLabelRotate: axisLabelRotate) {
    this.horizontalBarService.changeYAxisLabelRotate(this.options, yAxisLabelRotate);
    this.updateOptions();
  }

  _labelUnitSwitch: boolean = true;
  // 图形 label的单位
  @Input() 
  set bcacLabelUnitSwitch(labelUnitSwitch: boolean) {
    this._labelUnitSwitch = labelUnitSwitch;
    this.horizontalBarService.setLabelUnitSwitch(this.options, labelUnitSwitch);
  } 

  _bcacData: any = null;
  legendDataArr: any[] = [];
  // 图数据
  @Input()
  set bcacChartData(data: horizontalBarData) {

    if (data && data.hasOwnProperty('seriesName')) {
      let legendDataArr = [];
      data.seriesName.forEach(e => {
        legendDataArr.push({
          label: e,
          value: e,
          checked: true
        })
      })

      this.legendDataArr = legendDataArr;
      this.horizontalBarService.changeChartData(this.options, data, this._bcacTooltipUnit, this.isDarkMode, this._labelUnitSwitch)
    }
    this.updateOptions()
  }

  legendChange(e) {
    this.horizontalBarService.topLegendChange(e, this.chartInstance);
  }

  dataSourceSelectShow: boolean = false;
  dataSourceSelectData: any[] = []
  @Input()
  set bcacDataSourceList(value: any[]) {
    if (Array.isArray(value) && value.length > 0) {
      this.dataSourceSelectData = value;
      this.dataSourceSelectShow = true;
    } else {
      this.dataSourceSelectShow = false;
    }
  }

  singleSelectIconShow: boolean = false;
  intervalData: any[] = []
  intervalSelectedData: string | number = '';
  @Input()
  set bcacIntervalData(value: any[]) {

    if (Array.isArray(value) && value.length > 0) {
      this.intervalData = value;
      this.singleSelectIconShow = true;
      if (value.length == 1) {
        this.axisScaleChange(value[0].value);
        this.singleSelectIconShow = false;
      }
    } else {
      this.singleSelectIconShow = false;
    }
  }
  intervalSelectedDataChange(interval: any) {
    this.horizontalBarService.setInterval(this.options, interval);
    this.updateOptions();
  }

  axisScaleChange(interval: any) {
    this.horizontalBarService.setInterval(this.options, interval);
    this.updateOptions();
  }

  legendPosition: legendPosition = 'bottom';
  @Input()
  set bcacLegendPosition(value: legendPosition) {
    this.legendPosition = value;
    this.horizontalBarService.setLegendPosition(this.options, this.legendPosition)
  }


  // 图等待
  _bcacChartLoading: boolean = false;
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }

  // card 背景色
  @Input()
  set bcacCardBackground(cardBackground: string) {
    if (cardBackground) {
      this._cardBackgroundColor = cardBackground;
    }
  }

  @Input()
  set bcacChartBackground(chartBackground: string) {
    this.horizontalBarService.changeBackground(this.options, chartBackground);
  }

  _cardPadding = '1rem';
  isSmallMode: boolean = false;
  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (typeof (smallMode) === 'boolean' && smallMode) {
      this.isSmallMode = true;
      this.changeCardPadding(smallMode);
      this.chartResizeService.openSmallMode(this.options, this.isSmallMode, this.legendPosition);
      // this.chartResizeService.configSplitLine(false, this.options);
      this.updateOptions();
    } else {
      this.isSmallMode = false;
    }
  }

  @Input()
  set bcacAxisSplitLine(axisSplitLineShow: boolean) {
    if (axisSplitLineShow == true) {
      this.chartResizeService.configSplitLine(true, this.options, 'x')
    } else {
      this.chartResizeService.configSplitLine(false, this.options, 'x')
    }
  }

  @Input()
  set bcacTitle(chartTitle: string) {
    this.horizontalBarService.changeTitleOption(this.options, chartTitle, this.isSmallMode, this.legendPosition);
  }

  isDarkMode: boolean = false
  @Input()
  set bcacDarkMode(darkMode: boolean | string) {
    if (darkMode) {
      this.isDarkMode = true
    }

    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
    this.chartDarkModeService.openDarkMode(this.options, darkMode)
  }

  @Input()
  set bcacXAxisMin(xAxisMin: number) {
    this.horizontalBarService.setXAxisMin(this.options, xAxisMin)
  }

  @Input()
  set bcacXAxisMax(xAxisMax: number) {
    this.horizontalBarService.setXAxisMax(this.options, xAxisMax);
  }

  @Input()
  set bcacYAxisInterval(xAxisInterval: number) {
    this.horizontalBarService.setXAxisInterval(this.options, xAxisInterval)
  }

  @Input()
  set bcacColors(chartColors) {
    if (Array.isArray(chartColors)) {
      this.commonService.changeChartColors(this.options, chartColors)
    }
  }

  @Output() bcacGetChartInstance: EventEmitter<ECharts> = new EventEmitter<ECharts>();

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }

  initOpts;
  ngOnInit() {
    this.initOpts = initOpts;
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.chartInstance, this.options);
    })
  }

  // 更新图
  updateOptions() {
    if (this.chartInstance) {
      this.chartInstance.setOption(this.options, true)
    }
  }

  chartInstance: ECharts;
  onOptionInit(ec) {
    this.chartInstance = ec;

    this.bcacGetChartInstance.emit(ec);
  }
  // 选择显示的数据源
  selectedDataChange($event) {
    this._bcacData.forEach(element => {
      if (element.name === $event) {
        this.horizontalBarService.changeChartData(this.options, element.data)
        this.updateOptions()
        return;
      }
    })
  }

  setCardBackgroundColor() {
    if (this._cardBackgroundColor) {
      return this._cardBackgroundColor;
    } else {
      return '#FFF'
    }
  }

  // 改变卡片padding
  changeCardPadding(smallMode: boolean) {
    if (smallMode) {
      this._cardPadding = '0rem';
    } else {
      this._cardPadding = '1rem';
    }
  }

  _chartTitleColor = ""
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this._chartTitleColor = ''
    } else {
      this._chartTitleColor = color.darkModeTextColor;
    }
  }

  _cardBackgroundColor = "#FFF";
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this._cardBackgroundColor = darkMode;
    } else if (darkMode) {
      this._cardBackgroundColor = backgroundColor.darkModeBGColor;
    }
  }

}
